import BlueButton from "../BlueButton/BlueButton";
import { useTranslation } from "react-i18next";
const TestMemeButtonDisplay = ({ createTestMemeOnClick, testMemeMessage }) => {
    const { t } = useTranslation("testMemeContainer");
    return (
        <div className="testMemeContainer">
            <div className="testMemeContent">
                <BlueButton
                    text={t("testButton")}
                    onClick={createTestMemeOnClick}
                    isLarge={true}
                />
                <span className="testMemeMessageText">{testMemeMessage}</span>
            </div>
        </div>
    );
};

export default TestMemeButtonDisplay;
